export var emailRegex = /^[a-zA-Z0-9!#$%&'*+\/=?\^_`{|}~\-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?\^_`{|}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/; // eslint-disable-line max-len

export var phoneRegex = /^[0-9-()+ ]{7,}$/;
export var urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/; // eslint-disable-line max-len

export var nameRegex = /^.{3,150}$/;
export var slugRegex = /^[a-zA-Z0-9-]+$/;
export var hexColorRegex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
export var searchKeywordRegex = /[*+^${}()|[\]\\":;<>=&%@#~`\/]/gi;